import React from 'react';

/** Top of the eco scale. `ecoScore` is device-reported 0-10, measured across the whole range. */
export const ECO_MAX = 10;

/**
 * Band thresholds are fleetconsole's `ecoBand`, verbatim — so the same score reads the same colour
 * in both tools. Higher is better, unlike every other column on these tables.
 */
export const ecoBand = (score) => {
    if (score === null || score === undefined) return null;
    if (score >= 8) return 'good';
    if (score >= 6) return 'ok';
    if (score >= 4) return 'warn';
    return 'bad';
};

/**
 * Eco-driving score as a banded pill.
 *
 * Null renders an em dash, never a zero: 0 is the *worst* possible score, so printing it for an
 * asset that simply reports no eco data would flag a careful fleet as reckless.
 */
const OdEcoPill = (props) => {
    const { score, title } = props;
    const band = ecoBand(score);

    if (band === null) {
        return <span className="od-cell-muted" title={title || 'No eco-driving data for this period'}>—</span>;
    }

    return (
        <span
          className={`od-eco-pill od-eco-${band}`}
          title={title || `Eco-driving score ${score.toFixed(1)} out of ${ECO_MAX}. Higher is better.`}
        >
            {score.toFixed(1)}
        </span>
    );
};

export default OdEcoPill;
